module.exports = __webpack_public_path__ + "media/slot-game/achieve-2e66fc7f.svg";